module.exports = __webpack_public_path__ + "static/media/2.a2e81327.png";